import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-send",
  "use": "icon-send-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-send\">\n<path d=\"M1.25 8.75L17.5 2.5L15 16.25L6.28875 11.5037L16.25 3.75L4.74625 10.6444L1.25 8.75ZM6.25 18.75V12.8319L10 15L6.25 18.75Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/send.svg
// module id = xSQU
// module chunks = 262